import { useState } from 'react';

import { cn } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Button from 'components/shared/Button/Button';
import ProgressBar from 'components/shared/ProgressBar/ProgressBar';
import { VIDEO_TRAINING_SUBSTEP_CODES } from 'components/shared/Stepper/lib/constants';

const VideoTrainingReview = (props) => {
  const [filterStatus, setFilterStatus] = useState('all');

  const usersData = props.data?.substeps?.find((s) =>
    VIDEO_TRAINING_SUBSTEP_CODES.includes(s.code)
  )?.data;

  const userDataMapped = !!usersData?.error
    ? []
    : usersData?.map((u) => ({
        id: u.user.id,
        name: u.user.fullName,
        completed: Math.floor(Number(u.progress?.completion_percentage ?? 0)),
        isCompleted: u.progress?.is_completed ?? false
      })) || [];

  const filteredUsers = userDataMapped.filter((user) => {
    if (filterStatus === 'completed') return user.isCompleted;
    if (filterStatus === 'uncompleted') return !user.isCompleted;
    return true;
  });

  const handleFilterClick = (status) => {
    setFilterStatus(status);
  };

  return (
    <div className="text-sm">
      {filteredUsers?.length > 10 && (
        <div className="flex gap-4 px-4 py-2">
          <Button
            text="All"
            size="xs"
            className={cn(
              'hover:border-2 hover:border-neutral-200 hover:bg-neutral-100',
              filterStatus === 'all' && 'border-2 border-neutral-200 bg-neutral-100'
            )}
            color="neutral"
            style="outlined"
            onClick={() => handleFilterClick('all')}
          />
          <Button
            text="Completed"
            size="xs"
            className={cn(
              'hover:border-2 hover:border-neutral-200 hover:bg-neutral-100',
              filterStatus === 'completed' && 'border-2 border-neutral-200 bg-neutral-100'
            )}
            color="neutral"
            style="outlined"
            onClick={() => handleFilterClick('completed')}
          />
          <Button
            text="Uncompleted"
            size="xs"
            className={cn(
              'hover:border-2 hover:border-neutral-200 hover:bg-neutral-100',
              filterStatus === 'uncompleted' && 'border-2 border-neutral-200 bg-neutral-100'
            )}
            color="neutral"
            style="outlined"
            onClick={() => handleFilterClick('uncompleted')}
          />
        </div>
      )}
      {filteredUsers.length > 0 ? (
        <>
          <div
            className={cn(
              'flex w-full items-center border border-l-0 border-r-0 border-solid border-neutral-300 bg-neutral-25 px-4 py-2',
              filteredUsers?.length < 10 && 'border-t-0'
            )}>
            <div className="w-3/4">Staff member</div>
            <div className="w-1/4 border-b-0 border-l border-r-0 border-t-0 border-solid border-neutral-300 pl-2">
              Completed
            </div>
          </div>
          {filteredUsers?.map((s) => (
            <div
              key={s.id}
              className="flex w-full items-center border-b border-l-0 border-r-0 border-t-0 border-solid border-neutral-300 px-4 py-3 last:border-none">
              <div className="flex w-3/4 items-center gap-2">
                <Avatar isSquare={false} fullName={s.name} size="small" />
                {s.name}
              </div>
              <div className="flex w-1/4 items-center gap-2 pl-2 pr-2">
                <ProgressBar
                  progressColor="bg-primary-500"
                  progress={s.completed}
                  className="w-full"
                />
                <span className="text-sm">{s.completed}%</span>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="px-4 py-3 text-sm text-neutral-500">No users to display</div>
      )}
    </div>
  );
};

export default VideoTrainingReview;
